
(function() {
  var module = {};
  var result = {};
  module.exports = { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분", "days": "{{ days }}일", "shortForm": { "seconds": "{{ seconds }}초", "minutes": "{{ minutes }}분", "hours": "{{ hours }}시간", "days": "{{ days }}일", "hoursAndMinutes": "{{ hours }}시간 {{ minutes }}분" } }, "dateTime": { "shortForm": { "months": { "january": "1월", "february": "2월", "march": "3월", "april": "4월", "may": "5월", "june": "6월", "july": "7월", "august": "8월", "september": "9월", "october": "10월", "november": "11월", "december": "12월" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{yearNumber}} {{monthName}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.446"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.446",
    "da": "static-7.446",
    "de": "static-7.446",
    "el": "static-7.446",
    "en": "static-7.446",
    "es-mx": "static-7.446",
    "es": "static-7.446",
    "fi": "static-7.446",
    "fr": "static-7.446",
    "it": "static-7.446",
    "ja": "static-7.446",
    "ko": "static-7.446",
    "nl": "static-7.446",
    "no": "static-7.446",
    "pl": "static-7.446",
    "pt-br": "static-7.446",
    "sv": "static-7.446",
    "zh-cn": "static-7.446",
    "zh-hk": "static-7.446"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.446'}); }
})();


